import { createEffect, Actions, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { CreatepasswordService } from '../../core/services/createPassword/create-password.service';
import {
  resetPasswordFailed,
  resetPasswordReceived,
  resetPasswordRequest,
} from '../actions/createPasswordAction';
import { SnackbarService } from '../../core/services/snackbar/snackbar.service';
import { CookieService } from '../../core/services/cookie/cookie.service';
import { Router } from '@angular/router';

@Injectable()
export class createPasswordEffect {
  constructor(
    private actions: Actions,
    private createpasswordService: CreatepasswordService,
    private snackbarService: SnackbarService,
    private cookie: CookieService,
    private router: Router,
  ) {}

  createPasswordRequest$ = createEffect(() =>
    this.actions.pipe(
      ofType(resetPasswordRequest),
      mergeMap((params) =>
        this.createpasswordService
          .createPasswordRequest(params.createPasswordParams)
          .pipe(
            map((data) => {
              localStorage.clear();
              this.cookie.clear();
              this.router.navigate(['./login']);
              this.snackbarService.success(data);
              return resetPasswordReceived({ data });
            }),
            catchError((error) => {
              this.snackbarService.handleError(error.message);
              return of(resetPasswordFailed({ error }));
            }),
          ),
      ),
    ),
  );
}
